module.exports = "https://bin.bnbstatic.com/_next/static/images/icon-mobile-0c69fce4f0d14b9adbc3fe098b8182fd.png";